// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"485faf16","307":"07187225","465":"83c6f26e","801":"dc6c67d3","896":"8727d464","940":"61e0ca21","941":"51840f20","988":"11635784"}[chunkId] + ".chunk.js";
};